import { useCallback, useState } from "react";

const useExpandedTrade = () => {
  const [expandedTradeId, setExpandedTradeId] = useState<number>();
  const toggleExpanded = useCallback(
    (tradeId: number) =>
      setExpandedTradeId((current) =>
        current === tradeId ? undefined : tradeId
      ),
    []
  );
  return { expandedTradeId, toggleExpanded };
};

export default useExpandedTrade;
